module.exports = __webpack_public_path__ + "static/media/country_bq.0b3dc68c.webp";